import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { Button, Tooltip } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { Play24Icon } from "@kaltura/ds-react-icons";
import { ButtonTextWrapper } from "../styled-components";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";

interface WatchButtonProps {
    className?: string;
    entryName: string;
    onClick?: () => void;
    href?: string;
    disabled?: boolean;
}

/**
 * "Watch VOD" button for the session card.
 */
export const WatchButton = ({ className = "", entryName, onClick, href, disabled }: WatchButtonProps) => {
    const sendButtonAnalytics = useButtonAnalytics();

    const handleClick = () => {
        sendButtonAnalytics("Session card - Watch VOD", ButtonClickAnalyticsType.LINK);
        onClick?.();
    };

    return (
        <Tooltip title={translate("Watch - %1", [entryName])} placement={"bottom"}>
            <Button
                color={"primary"}
                disabled={disabled}
                onClick={handleClick}
                href={href}
                startIcon={<Play24Icon />}
                className={`${className} kms-ds-event-list-item-button-watch`}
                size={"large"}
                aria-label={translate("Watch Button - %1", [entryName])}
            >
                <ButtonTextWrapper>{translate("Watch")}</ButtonTextWrapper>
            </Button>
        </Tooltip>
    );
};
